/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BulkOperation } from './bulkOperation';
import { ErrorResponse } from './errorResponse';


export interface BulkResponse { 
    schemas?: Array<string>;
    operations?: Array<BulkOperation>;
    status?: BulkResponse.StatusEnum;
    errorResponse?: ErrorResponse;
}
export namespace BulkResponse {
    export type StatusEnum = 'OK' | 'Created' | 'Accepted' | 'No Content' | 'Reset Content' | 'Partial Content' | 'Multiple Choices' | 'Moved Permanently' | 'Found' | 'See Other' | 'Not Modified' | 'Use Proxy' | 'Temporary Redirect' | 'Permanent Redirect' | 'Bad Request' | 'Unauthorized' | 'Payment Required' | 'Forbidden' | 'Not Found' | 'Method Not Allowed' | 'Not Acceptable' | 'Proxy Authentication Required' | 'Request Timeout' | 'Conflict' | 'Gone' | 'Length Required' | 'Precondition Failed' | 'Request Entity Too Large' | 'Request-URI Too Long' | 'Unsupported Media Type' | 'Requested Range Not Satisfiable' | 'Expectation Failed' | 'Precondition Required' | 'Too Many Requests' | 'Request Header Fields Too Large' | 'Unavailable For Legal Reasons' | 'Internal Server Error' | 'Not Implemented' | 'Bad Gateway' | 'Service Unavailable' | 'Gateway Timeout' | 'HTTP Version Not Supported' | 'Network Authentication Required';
    export const StatusEnum = {
        Ok: 'OK' as StatusEnum,
        Created: 'Created' as StatusEnum,
        Accepted: 'Accepted' as StatusEnum,
        NoContent: 'No Content' as StatusEnum,
        ResetContent: 'Reset Content' as StatusEnum,
        PartialContent: 'Partial Content' as StatusEnum,
        MultipleChoices: 'Multiple Choices' as StatusEnum,
        MovedPermanently: 'Moved Permanently' as StatusEnum,
        Found: 'Found' as StatusEnum,
        SeeOther: 'See Other' as StatusEnum,
        NotModified: 'Not Modified' as StatusEnum,
        UseProxy: 'Use Proxy' as StatusEnum,
        TemporaryRedirect: 'Temporary Redirect' as StatusEnum,
        PermanentRedirect: 'Permanent Redirect' as StatusEnum,
        BadRequest: 'Bad Request' as StatusEnum,
        Unauthorized: 'Unauthorized' as StatusEnum,
        PaymentRequired: 'Payment Required' as StatusEnum,
        Forbidden: 'Forbidden' as StatusEnum,
        NotFound: 'Not Found' as StatusEnum,
        MethodNotAllowed: 'Method Not Allowed' as StatusEnum,
        NotAcceptable: 'Not Acceptable' as StatusEnum,
        ProxyAuthenticationRequired: 'Proxy Authentication Required' as StatusEnum,
        RequestTimeout: 'Request Timeout' as StatusEnum,
        Conflict: 'Conflict' as StatusEnum,
        Gone: 'Gone' as StatusEnum,
        LengthRequired: 'Length Required' as StatusEnum,
        PreconditionFailed: 'Precondition Failed' as StatusEnum,
        RequestEntityTooLarge: 'Request Entity Too Large' as StatusEnum,
        RequestUriTooLong: 'Request-URI Too Long' as StatusEnum,
        UnsupportedMediaType: 'Unsupported Media Type' as StatusEnum,
        RequestedRangeNotSatisfiable: 'Requested Range Not Satisfiable' as StatusEnum,
        ExpectationFailed: 'Expectation Failed' as StatusEnum,
        PreconditionRequired: 'Precondition Required' as StatusEnum,
        TooManyRequests: 'Too Many Requests' as StatusEnum,
        RequestHeaderFieldsTooLarge: 'Request Header Fields Too Large' as StatusEnum,
        UnavailableForLegalReasons: 'Unavailable For Legal Reasons' as StatusEnum,
        InternalServerError: 'Internal Server Error' as StatusEnum,
        NotImplemented: 'Not Implemented' as StatusEnum,
        BadGateway: 'Bad Gateway' as StatusEnum,
        ServiceUnavailable: 'Service Unavailable' as StatusEnum,
        GatewayTimeout: 'Gateway Timeout' as StatusEnum,
        HttpVersionNotSupported: 'HTTP Version Not Supported' as StatusEnum,
        NetworkAuthenticationRequired: 'Network Authentication Required' as StatusEnum
    };
}


